import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Select,
  Spinner,
  Text,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Spacer,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useRecoilState, useSetRecoilState } from "recoil";
import { FiArrowLeft, FiPlus } from "react-icons/fi";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import moment from "moment";
import { NumericFormat, PatternFormat } from "react-number-format";
import { useEffect, useState } from "react";
import bancos from "bancos-brasileiros";
import { cnpj as cnpjValidator, cpf as cpfValidator } from "cpf-cnpj-validator";
import { refreshGlobal } from "../../../../atoms/refreshGlobal";
import { dateForAPI } from "../../../../constants/dataFormat";
import ExtratoApi from "../../../../services/ExtratoAPI";
import TransferApiDireto from "../../../../services/TransferApiDireto";
import SysTypesApi from "../../../../services/sysTypesApi";
import { goToTransferSolicitationListNew } from "../../../../routes/coordinator";
import BankSelector from "../../../../defaultComponents/bankSelector";
import { JWTToken } from "../../../vendas/listaDeVendas/components/SalesList";
import jwt_decode from "jwt-decode";
import SelectFavorite from "./Selectfavorite";
import { Favorites } from "../../../../interfaces/defaultInterfaces";
import { customColors } from "../../../../atoms/customColors";
import { selectedClientHeader } from "../../../../atoms/selectedClientHeader";
import { LoggedUser } from "../../../../atoms/userLogged";
import ModalConfirmTransf from "./modalConfirmTransf";
import { tipoPixState } from "../../../../atoms/tipoPixState";
import {
  CPFFormater,
  CNPJFormater,
  PhoneFormater,
  CaptionFormater,
} from "../../../../defaultFunctions/formaters";
export default function AddTransferNew() {
  const navigate = useNavigate();
  const colors = useRecoilState(customColors)[0];
  const setRefreshGlobal = useSetRecoilState(refreshGlobal);
  const refresh = useRecoilState(refreshGlobal)[0];
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPagamento({ ...pagamento, [name]: value });
  };

  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const user = useRecoilState(LoggedUser)[0];
  const selectedId = useRecoilState(selectedClientHeader)[0];
  const id =
    user.idLoginTipo === 4 ? Number(jwtToken.idCliente) : Number(selectedId);
  // const id = Number(jwtToken.idCliente);
  const [tipoPix, setTipoPix] = useRecoilState(tipoPixState);
  const handleTabChange = (index: number) => {
    switch (index) {
      case 0:
        setTipoPix("CONTA");
        break;
      case 1:
        setTipoPix("CHAVE");
        break;
      case 2:
        setTipoPix("CHAVE");
        break;
      default:
        setTipoPix("CHAVE");
    }
  };
  console.log("tipoPix atual:", tipoPix);
  const handleChange = (index: number) => {
    handleTabChange(index);
    setFormValues(initialValues);
  };
  const formatarChavePix = (chave: string, tipoChave: string) => {
    // console.log(chave, tipoChave);
    let chaveFormatada = pagamento.chavePix;
    switch (pagamento.tipoChave) {
      case "CPF":
        chaveFormatada = CPFFormater(chave);
        break;
      case "CNPJ":
        chaveFormatada = CNPJFormater(chave);
        break;
      case "CELULAR":
        chaveFormatada = PhoneFormater(chave);
        break;
      case "EVP":
      case "EMAIL":
        chaveFormatada = chave;
        break;
      default:
        break;
    }
    return chaveFormatada;
  };

  const todayMorning = moment()
    .startOf("day")
    .format("YYYY-MM-DDTHH:mm:ss.SSS");
  const todayNight = moment().format("YYYY-MM-DDTHH:mm:ss.SSS");
  const [saldoCliente, setSaldoCliente] = useState(0);
  const [favorite, setFavorite] = useState<Favorites>();

  interface User {
    id: number;
    nome: string;
    email: string;
    ativo: boolean;
    idEmpresa?: number | null;
    idCliente?: number | null;
    idVendedor?: number | null;
    idProjeto?: number | null;
    idLoginTipo: number;
    apiout: boolean;
    primeiroAcesso: boolean;
    expiracaoSenha: string;
    idTipoGestor?: number | null;
    loginControle: {
      idLogin: number;
      primeiroAcesso: boolean;
      expiracaoSenha: string;
      celular?: string | null;
      tipo2FA?: string | null;
      isAtivo?: boolean | null;
      idTipoUsuario?: number | null;
    };
  }

  interface IFormInputs {
    idCliente: number;
    idTipoConta: number;
    nomeDestinatario: string;
    cnpjDestinatario: string;
    observacao: string;
    nroBanco: string;
    nroAgencia: string;
    nroAgenciaDigito: string;
    nroConta: string;
    nroContaDigito: string;
    valor: number;
    data: string;
    tipoPix: string;
    tipoChave: string;
    chavePix: string;
  }

  const initialValues = {
    idCliente: id,
    idTipoConta: favorite ? favorite.idTipoConta : 1,
    nomeDestinatario: favorite ? favorite.nomeTitular : "",
    cnpjDestinatario: favorite ? favorite.docTitular : "",
    observacao: "",
    nroBanco: favorite ? favorite.nroBanco : "001",
    nroAgencia: favorite ? favorite.nroAgencia : "",
    nroAgenciaDigito: favorite ? favorite.nroAgenciaDigito : "",
    nroConta: favorite ? favorite.nroConta : "",
    nroContaDigito: favorite ? favorite.nroContaDigito : "",
    valor: 0,
    tipoPix: tipoPix,
    tipoChave: favorite ? favorite.tipoChave : "",
    chavePix: favorite ? favorite.chavePix : "",

    data: moment(new Date()).format(dateForAPI),
  };
  useEffect(() => {
    setPagamento(initialValues);
    // console.log("favorite", favorite);
  }, [favorite]);

  const [pagamento, setPagamento] = useState<IFormInputs>(initialValues);
  const [listaPagamento, setListaPagamento] = useState(Array<IFormInputs>);
  const [loading, setLoading] = useState(false);
  const [loadingCadastro, setLoadingCadastro] = useState(false);

  useEffect(() => {
    const tabs = document.querySelectorAll(".chakra-tabs__tab");
    tabs.forEach((tab) => {
      tab.addEventListener("click", clearObjectValues);
    });

    return () => {
      tabs.forEach((tab) => {
        tab.removeEventListener("click", clearObjectValues);
      });
    };
  }, []);

  function clearObjectValues() {
    setPagamento(initialValues);
  }
  const schema = yup
    .object({
      vencimento: yup
        .string()
        .required("A data de vencimento deve ser preenchida!"),
      codigoBarras: yup.string().required("Digite o código de barras!"),
      // hora: yup.string().required("A hora do laançamento deve ser preenchida"),
      // valorNominal: yup.number().required("O valorNominal deve ser preenchido")
    })
    .required();
  const {
    register,
    handleSubmit,
    watch,
    setError,
    formState: { errors },
  } = useForm<IFormInputs>({ resolver: yupResolver(schema) });

  async function getSaldo() {
    try {
      setLoading(true);

      const response = await ExtratoApi.getSaldo(
        1,
        100,
        todayMorning,
        todayNight,
        id
      );
      setSaldoCliente(
        response.data[0] &&
        parseFloat(
          (
            response.data[0].saldoAnterior + response.data[0].saldoPeriodo
          ).toFixed(2)
        )
      );
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("Erro ao carregar saldo, por favor recarregue a página.");
    }
  }
  useEffect(() => {
    getSaldo();
  }, [id]);

  const transferData = {
    ...pagamento,
    idCliente: id,
    dataTransferencia: moment(new Date()).format("YYYY-MM-DDTHH:mm:ss.SSS"),
  };

  function onSubmit(code: any) {
    const validarData = new Date();

    if (
      true
      /*      pagamento.cnpjDestinatario !== "" &&
      pagamento.nomeDestinatario !== "" &&
      pagamento.nroAgencia !== "" &&
      pagamento.nroConta !== "" &&
      pagamento.nroContaDigito !== "" &&
      pagamento.valor > 0 &&
      pagamento.idTipoConta > 0 */
    ) {
      if (saldoCliente >= pagamento.valor) {
        const objeto = {
          idCliente: id,
          tipoPix: tipoPix,
          tipoChave: pagamento.tipoChave,
          chavePix: ["CNPJ", "CPF", "CELULAR"].includes(pagamento.tipoChave)
            ? unMask(pagamento.chavePix)
            : pagamento.chavePix,
          idTipoConta: pagamento.idTipoConta,
          nomeDestinatario: pagamento.nomeDestinatario,
          cnpjDestinatario: unMask(pagamento.cnpjDestinatario),
          observacao: pagamento.observacao,
          nroBanco: pagamento.nroBanco,
          nroAgencia: pagamento.nroAgencia,
          nroAgenciaDigito: "D",
          nroConta: pagamento.nroConta,
          nroContaDigito: pagamento.nroContaDigito,
          valor: pagamento.valor,
          dataTransferencia: moment(new Date()).format(dateForAPI),
        };
        // console.log("objeto", objeto);
        postTransferencias(objeto, code);
      } else {
        toast.error("O saldo não é suficiente para a solicitação!");
      }
    } else {
      toast.error(
        "Preencha os dados para realizar a solicitação de transferência!"
      );
    }
  }

  // const validarSeFinalDeSemana = () => {
  //   const validarData = new Date();
  //   const NaoFinalDeSemana =
  //     validarData.getDay() !== 5 && validarData.getDay() !== 6;
  //   const e_valido = validarMesmoDiaEAntesDasDezesseisHoras(validarData);
  //   if (e_valido) {
  //     if (NaoFinalDeSemana) {
  //       setPagamento({
  //         ...pagamento,
  //         data: moment(validarData).format("YYYY-MM-DDTHH:mm:ss.SSS"),
  //       });
  //       return true;
  //     } else {
  //       toast.error("A data não pode ser um final de semana!");
  //       return false;
  //     }
  //   } else {
  //     toast.error(
  //       "Não é possível realizar solicitações para o mesmo dia após as 16hs!"
  //     );
  //     return false;
  //   }
  // };

  function validarMesmoDiaEAntesDasDezesseisHoras(data: any) {
    const horaDaSolicitacao = moment().format("HH.mm");
    const diadaSolicitação =
      moment().format("DD-MM-YYYY") === moment(data).format("DD-MM-YYYY");
    if (diadaSolicitação) {
      if (Number(horaDaSolicitacao) < 16) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  const [code, setCode] = useState("");

  async function postTransferencias(obj: any, codeResponse: string) {
    if (obj.idCliente === 0) {
      toast.error("Selecione um cliente para fazer a solicitação");
      setLoadingCadastro(false);
      return;
    }

    setLoadingCadastro(true);

    try {
      await TransferApiDireto.postTransferSolicitation(obj);

      toast.success("Solicitação de transferência registrada com sucesso!");
      toast.success("Sua transferência será processada em breve!");

      setRefreshGlobal(refresh + 1);
      setPagamento(initialValues);
      goToTransferSolicitationListNew(navigate);
      setLoadingCadastro(false);
    } catch (error) {
      toast.error("Não foi possível cadastrar a solicitação");
      setLoadingCadastro(false);
    }
  }
  function OnChangeValueInput(e: any) {
    setPagamento({ ...pagamento, valor: Number(e.slice(3).replace(",", ".")) });
  }

  function sumPaymentList() {
    const valores = listaPagamento
      .map((item: any) => item.valorNominal)
      .reduce((a, b) => a + b, 0);
    return valores;
  }

  let soma = sumPaymentList().toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

  const bancoOptions = bancos.map((banco: any, i: any) => {
    return {
      key: i,
      text: `${banco.COMPE} - ${banco.LongName}`,
      value: banco.COMPE,
    };
  });

  const [types, setTypes] = useState([
    {
      id: 0,
      nome: "",
    },
  ]);

  const getTypeAccount = async () => {
    try {
      const response = await SysTypesApi.sysTypeAccount(1, 100, "");
      setTypes(response);
    } catch (error: any) {
      // console.log(error);
    }
  };
  useEffect(() => {
    getTypeAccount();
  }, []);

  const unMask = (value: any) => {
    return value.replace(/[^0-9]/g, "");
  };

  function validateCNPJ(cnpj: any) {
    const temp = cnpj.match(/\d/g).join("");
    if (temp.length > 11) {
      if (!cnpjValidator.isValid(temp)) {
        setError("cnpjDestinatario", {
          type: "onBlur",
          message: "Este CNPJ não é válido!",
        });
      } else {
        setError("cnpjDestinatario", { type: "onBlur", message: "" });
      }
    } else {
      if (!cpfValidator.isValid(temp)) {
        setError("cnpjDestinatario", {
          type: "onBlur",
          message: "Este CPF não é válido!",
        });
      } else {
        setError("cnpjDestinatario", { type: "onBlur", message: "" });
      }
    }
  }
  const [openCodeModal, setOpenCodeModal] = useState(false);

  const [formValues, setFormValues] = useState(initialValues);

  const handleFormInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  return (
    <Flex flexDir={"column"} height="fit-content" width="100%">
      <Box
        width="100%"
        bgColor={colors.WHITE}
        height="fit-content"
        shadow="md"
        mt="0.3%"
        mx="auto"
        py={2}
        px={3}
      >
        <Flex alignItems="center" px={5}>
          <Text fontWeight="bold" fontSize="18px">
            Nova Solicitação de Transferência PIX
          </Text>
          <Spacer />
          <Button
            leftIcon={<FiArrowLeft />}
            bgColor={colors.GRAY_NEUTRAL}
            color="white"
            onClick={() => {
              goToTransferSolicitationListNew(navigate);
            }}
          >
            Voltar
          </Button>
        </Flex>
      </Box>

      <Flex w={"100%"} h={"84vh"} overflowY={"scroll"} flexDirection={"column"}>
        <Box
          width={"100%"}
          bgColor={colors.WHITE}
          height={"fit-content"}
          shadow={"md"}
          justifyItems={"center"}
          mt={"0.3%"}
          mx="auto"
          py={2}
          px={3}
        >
          <Flex justify="flex-start" ml={4} flexDirection={"column"}>
            <Text
              fontSize={"12px"}
              fontWeight={"500"}
              color={colors.BLUEMONEDD}
              my={1}
            >
              * Solicitações de transferências bancárias só são possíveis de 08h
              até ás 17h, de segunda a sexta exceto feriados.
            </Text>
            <Text
              fontSize={"12px"}
              fontWeight={"500"}
              color={colors.BLUEMONEDD}
              my={1}
            >
              * Não é possível realizar solicitações de transferências bancárias
              após as 17:00, em finais de semana e feriados nacionais.
            </Text>
            <Text
              fontSize={"12px"}
              fontWeight={"500"}
              color={colors.BLUEMONEDD}
              my={1}
            >
              * Importante: Todas as transferências realizadas que tiverem
              registrado em suas contas, CHAVE PIX, serão processados como PIX
              no banco.
            </Text>
            <Text
              fontSize={"12px"}
              fontWeight={"500"}
              color={colors.BLUEMONEDD}
              my={1}
            >
              * A partir de 1º de Novembro de 2023, todo cliente MONEDD tem o
              benefício de 20 Transferências GRATUÍTAS dentro de cada mês e sem
              limite diário. A partir da 21ª transferência dentro do mês, custo
              unitário de R$ 4,50 por transferência sendo fechamento e
              lançamento mensal.
            </Text>
          </Flex>
        </Box>
        <Box
          width={"100%"}
          bgColor={colors.WHITE}
          height={"fit-content"}
          shadow={"md"}
          mt={"0.3%"}
          mx="auto"
          py={3}
          px={10}
        >
          <Flex width={"100%"} height={"60%"} flexDirection="column" mb={"3%"}>
            <Tabs onChange={handleChange} defaultIndex={1}>
              <TabList>
                <Tab>Pix por conta bancária</Tab>
                <Tab>Pix por chave</Tab>
                <Tab>Pix copia e cola</Tab>
              </TabList>
              <TabPanels>
                <TabPanel>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <Flex
                      my={2}
                      flexDirection={"column"}
                      justifyContent="center"
                    >
                      <Text fontWeight={"bold"} my={1}>
                        Saldo:{" "}
                        {loading ? (
                          <Spinner
                            size={"sm"}
                            color={colors.BLUEMONEDDBUTTONS}
                          ></Spinner>
                        ) : saldoCliente ? (
                          saldoCliente.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })
                        ) : (
                          "R$ 0,00"
                        )}
                      </Text>
                    </Flex>
                    <FormControl my={2} w={"40%"}>
                      <FormLabel fontWeight={"bold"} fontSize={"16px"} mt={2}>
                        Lista de Favorecidos
                      </FormLabel>
                      <SelectFavorite cliente={id} setFavorite={setFavorite} />
                    </FormControl>
                    <Flex flexDir={"row"}>
                      <FormControl my={2} mx={2}>
                        <FormLabel fontWeight={"bold"} fontSize={"16px"} mt={2}>
                          Nome do Destinatário
                        </FormLabel>
                        <Input
                          placeholder="Digite o nome"
                          value={pagamento.nomeDestinatario}
                          {...register("nomeDestinatario", { required: true })}
                          onChange={(e: any) => {
                            setPagamento({
                              ...pagamento,
                              nomeDestinatario: e.target.value,
                            });
                          }}
                        />
                      </FormControl>
                    </Flex>
                    <Flex flexDir={"row"}>
                      <FormControl my={2} mx={2}>
                        <FormLabel fontWeight={"bold"} fontSize={"16px"} mt={2}>
                          CPF/CNPJ do Destinatário
                        </FormLabel>
                        <PatternFormat
                          customInput={Input}
                          format={
                            unMask(pagamento.cnpjDestinatario).length > 11
                              ? "##.###.###/####-##"
                              : "###.###.###-###"
                          }
                          type="text"
                          placeholder="Digite o CPF ou CNPJ"
                          value={pagamento.cnpjDestinatario}
                          // {...register("cnpjDestinatario", { required: true })}
                          onChange={(e: any) => {
                            setPagamento({
                              ...pagamento,
                              cnpjDestinatario: e.target.value,
                            });
                          }}
                          onBlur={(e: any) => {
                            validateCNPJ(e.target.value);
                          }}
                        />
                        <Text color={colors.REDMONEDD}>
                          {errors.cnpjDestinatario?.message}
                        </Text>
                      </FormControl>
                      <FormControl my={2} mx={2}>
                        <FormLabel fontWeight={"bold"} fontSize={"16px"} mt={2}>
                          Valor
                        </FormLabel>
                        <NumericFormat
                          decimalScale={2}
                          prefix="R$ "
                          value={pagamento.valor}
                          decimalSeparator=","
                          customInput={Input}
                          type="text"
                          placeholder="R$ 0,00"
                          onChange={(e: any) => {
                            OnChangeValueInput(e.target.value);
                          }}
                        />
                      </FormControl>
                      <FormControl my={2} mx={2}>
                        <FormLabel fontWeight={"bold"} fontSize={"16px"} mt={2}>
                          Observação
                        </FormLabel>
                        <Input
                          placeholder="observações..."
                          value={pagamento.observacao}
                          {...register("observacao")}
                          onChange={(e: any) => {
                            setPagamento({
                              ...pagamento,
                              observacao: e.target.value,
                            });
                          }}
                        />
                      </FormControl>
                    </Flex>
                    <Flex flexDir={"row"}>
                      <FormControl
                        isInvalid={errors.nroBanco ? true : false}
                        my={2}
                        mx={2}
                      >
                        <FormLabel fontWeight={"bold"} fontSize={"16px"}>
                          Banco
                        </FormLabel>
                        <FormLabel
                          fontSize={"16px"}
                          style={{ border: "1px solid #EEEEEE" }}
                          borderRadius="md"
                        >
                          <BankSelector
                            banco={pagamento}
                            setBanco={setPagamento}
                          />
                        </FormLabel>
                        <FormErrorMessage>
                          {errors.nroBanco?.message}
                        </FormErrorMessage>
                      </FormControl>
                    </Flex>
                    <Flex flexDir={"row"}>
                      <FormControl
                        isInvalid={errors.nroAgencia ? true : false}
                        my={2}
                        mx={2}
                      >
                        <FormLabel fontWeight={"bold"} fontSize={"16px"}>
                          <Text>
                            Agência{" "}
                            <span style={{ fontWeight: "bold", color: "red" }}>
                              (sem Dígito)
                            </span>
                          </Text>
                        </FormLabel>
                        {/* <PatternFormat
                          format={"####"}
                          placeholder="NNNN"
                          // mask={["N", "N", "N", "N"]}
                          w={"160px"}
                          customInput={Input}
                          value={pagamento.nroAgencia}
                          {...register("nroAgencia", { required: true })}
                          onChange={(e: any) => {
                            setPagamento({
                              ...pagamento,
                              nroAgencia: e.target.value,

                            });
                          }}
                        /> */}
                        <Input
                          type="text"
                          maxLength={4}
                          placeholder="NNNN"
                          w={"160px"}
                          value={pagamento.nroAgencia}
                          {...register("nroAgencia", { required: true })}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, ""); // Remove caracteres não numéricos
                            setPagamento({
                              ...pagamento,
                              nroAgencia: value,
                            });
                          }}
                        />
                        <FormErrorMessage>
                          {errors.nroAgencia?.message}
                        </FormErrorMessage>
                      </FormControl>

                      <FormControl
                        isInvalid={errors.nroConta ? true : false}
                        my={2}
                        mx={2}
                      >
                        <FormLabel fontWeight={"bold"} fontSize={"16px"}>
                          <Text>
                            Número da Conta{" "}
                            <span style={{ fontWeight: "bold", color: "red" }}>
                              (sem Dígito)
                            </span>
                          </Text>
                        </FormLabel>
                        <Flex
                          flexDirection={"row"}
                          justifyContent={"start"}
                          alignItems={"center"}
                        >
                          <Input
                            type="text"
                            maxLength={10}
                            w={"260px"}
                            mx={1}
                            placeholder="Número da conta"
                            value={pagamento.nroConta}
                            {...register("nroConta", { required: true })}
                            onChange={(e: any) => {
                              setPagamento({
                                ...pagamento,
                                nroConta: e.target.value,
                                tipoPix: "CONTA",
                              });
                            }}
                          />
                        </Flex>
                        <FormErrorMessage>
                          {errors.nroConta?.message}
                        </FormErrorMessage>
                      </FormControl>
                      <FormControl my={2} mx={2}>
                        <FormLabel fontWeight={"bold"} fontSize={"16px"}>
                          <Text>
                            {" "}
                            <span style={{ fontWeight: "bold", color: "red" }}>
                              Dígito
                            </span>{" "}
                            da conta
                          </Text>
                        </FormLabel>
                        <Input
                          type="text"
                          maxLength={1}
                          w={"50px"}
                          placeholder="X"
                          value={pagamento.nroContaDigito}
                          {...register("nroContaDigito", { required: true })}
                          onChange={(e: any) => {
                            setPagamento({
                              ...pagamento,
                              nroContaDigito: e.target.value,
                            });
                          }}
                        />
                      </FormControl>
                      <FormControl
                        isInvalid={errors.idTipoConta ? true : false}
                        my={2}
                        mx={2}
                      >
                        <FormLabel fontWeight={"bold"} fontSize={"16px"}>
                          Tipo de conta
                        </FormLabel>
                        <Select
                          value={pagamento.idTipoConta}
                          {...register("idTipoConta", { required: true })}
                          onChange={(e: any) => {
                            setPagamento({
                              ...pagamento,
                              idTipoConta: Number(e.target.value),
                            });
                          }}
                        >
                          {types &&
                            types.map((item: any) => {
                              return (
                                <option key={item.id} value={item.id}>
                                  {item.nome}
                                </option>
                              );
                            })}
                        </Select>
                        <FormErrorMessage>
                          {errors.idTipoConta?.message}
                        </FormErrorMessage>
                      </FormControl>
                    </Flex>
                    <Button
                      isDisabled={
                        pagamento.cnpjDestinatario !== "" &&
                          pagamento.cnpjDestinatario.length >= 11 &&
                          pagamento.nomeDestinatario !== "" &&
                          pagamento.nroAgencia !== "" &&
                          pagamento.nroAgencia.length === 4 &&
                          pagamento.nroConta !== "" &&
                          pagamento.nroContaDigito !== "" &&
                          pagamento.valor > 0 &&
                          pagamento.idTipoConta > 0
                          ? false
                          : true && id > 0
                      }
                      type="submit"
                      onClick={() => {
                        setTipoPix("CONTA");
                        setPagamento({ ...pagamento, tipoPix: "CONTA" });
                        setOpenCodeModal(true)
                      }}
                      mt={5}
                      leftIcon={<FiPlus />}
                      bgColor={colors.BLUEMONEDDBUTTONS}
                      style={{ color: "white" }}
                      _hover={{ bg: "#4B4B57" }}
                      isLoading={loadingCadastro}
                    >
                      Efetuar Transferência por Conta Bancária
                    </Button>
                  </form>
                </TabPanel>

                <TabPanel>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <Flex
                      my={2}
                      flexDirection={"column"}
                      justifyContent="center"
                    >
                      <Text fontWeight={"bold"} my={1}>
                        Saldo:{" "}
                        {loading ? (
                          <Spinner
                            size={"sm"}
                            color={colors.BLUEMONEDDBUTTONS}
                          ></Spinner>
                        ) : saldoCliente ? (
                          saldoCliente.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })
                        ) : (
                          "R$ 0,00"
                        )}
                      </Text>
                      <Flex
                        flexDirection={"row"}
                        justifyContent={"space-between"}
                      >
                        <FormControl my={2} w={"40%"}>
                          <FormLabel
                            fontWeight={"bold"}
                            fontSize={"16px"}
                            mt={2}
                          >
                            Lista de Favorecidos
                          </FormLabel>
                          <SelectFavorite
                            cliente={id}
                            setFavorite={setFavorite}
                          />
                        </FormControl>
                        <FormControl my={2} mx={2}>
                          <FormLabel
                            fontWeight={"bold"}
                            fontSize={"16px"}
                            mt={2}
                          >
                            Observação
                          </FormLabel>
                          <Input
                            placeholder="observações..."
                            value={pagamento.observacao}
                            {...register("observacao")}
                            onChange={(e: any) => {
                              setPagamento({
                                ...pagamento,
                                observacao: e.target.value,
                              });
                            }}
                          />
                        </FormControl>
                      </Flex>
                      <Flex
                        flexDirection={"row"}
                        justifyContent={"space-between"}
                      >
                        <FormControl my={2} w={"35%"}>
                          <FormLabel
                            fontWeight={"bold"}
                            fontSize={"16px"}
                            mt={2}
                          >
                            Tipo Chave
                          </FormLabel>
                          <Select
                            onChange={(e) => {
                              setPagamento({
                                ...pagamento,
                                tipoChave: e.target.value,
                              });
                            }}
                            value={pagamento.tipoChave}
                          >
                            <option value="" disabled selected hidden>
                              ESCOLHA SEU MÉTODO
                            </option>
                            <option value="CPF">CPF</option>
                            <option value="CNPJ">CNPJ</option>
                            <option value="CELULAR">CELULAR</option>
                            <option value="EMAIL">EMAIL</option>

                            <option value="EVP">CHAVE ALEATÓRIA</option>
                          </Select>
                        </FormControl>
                        <FormControl my={2} w={"25%"}>
                          <FormLabel
                            fontWeight={"bold"}
                            fontSize={"16px"}
                            mt={2}
                          >
                            Valor
                          </FormLabel>
                          <NumericFormat
                            decimalScale={2}
                            prefix="R$ "
                            value={pagamento.valor}
                            decimalSeparator=","
                            customInput={Input}
                            type="text"
                            placeholder="R$ 0,00"
                            onChange={(e: any) => {
                              OnChangeValueInput(e.target.value);
                            }}
                          />
                        </FormControl>
                        <FormControl my={2} w={"35%"}>
                          <FormLabel
                            fontWeight={"bold"}
                            fontSize={"16px"}
                            mt={2}
                          >
                            Chave para Transferir
                          </FormLabel>
                          <Input
                            type="text"
                            name="chavePix"
                            placeholder="Digite a chave para transferir"
                            value={pagamento.chavePix}
                            onChange={handleInputChange}
                            onBlur={() => {
                              const chaveFormatada = formatarChavePix(
                                pagamento.chavePix,
                                pagamento.tipoChave
                              );
                              setPagamento({
                                ...pagamento,
                                chavePix: chaveFormatada,
                                tipoPix: "CHAVE",
                              });
                            }}
                          />
                        </FormControl>
                      </Flex>
                      <Button
                        isDisabled={
                          pagamento.tipoChave &&
                            pagamento.tipoChave.length > 0 &&
                            pagamento.chavePix &&
                            pagamento.chavePix.length > 0 &&
                            pagamento.valor > 0
                            ? false
                            : true
                        }
                        type="submit"
                        onClick={() => {
                          setTipoPix("CHAVE");
                          setPagamento({ ...pagamento, tipoPix: "CHAVE" });
                          setOpenCodeModal(true)
                        }}
                        mt={5}
                        leftIcon={<FiPlus />}
                        bgColor={colors.BLUEMONEDDBUTTONS}
                        style={{ color: "white", alignSelf: "flex-start" }}
                        _hover={{ bg: "#4B4B57" }}
                        isLoading={loadingCadastro}
                      >
                        Efetuar Transferência Com Chave PIX
                      </Button>
                    </Flex>
                  </form>
                </TabPanel>
                <TabPanel>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <Flex
                      my={2}
                      flexDirection={"column"}
                      justifyContent="center"
                    >
                      <Text fontWeight={"bold"} my={1}>
                        Saldo:{" "}
                        {loading ? (
                          <Spinner
                            size={"sm"}
                            color={colors.BLUEMONEDDBUTTONS}
                          ></Spinner>
                        ) : saldoCliente ? (
                          saldoCliente.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })
                        ) : (
                          "R$ 0,00"
                        )}
                      </Text>
                      <Flex
                        flexDirection={"row"}
                        justifyContent={"space-between"}
                      >
                        <FormControl my={2} w={"20%"}>
                          <FormLabel
                            fontWeight={"bold"}
                            fontSize={"16px"}
                            mt={2}
                          >
                            Tipo Chave
                          </FormLabel>
                          <Select
                            onChange={(e) => {
                              setPagamento({ ...pagamento, tipoChave: "EMV" });
                            }}
                            value="EMV"
                          >
                            <option value="EMV">PIX COPIA E COLA</option>
                          </Select>
                        </FormControl>
                        {/* <FormControl my={2} w={'25%'}>
                          <FormLabel fontWeight={"bold"} fontSize={"16px"} mt={2}>
                            Valor
                          </FormLabel>
                          <NumericFormat
                            decimalScale={2}
                            prefix="R$ "
                            value={pagamento.valor}
                            decimalSeparator=","
                            customInput={Input}
                            type="text"
                            placeholder="R$ 0,00"
                            onChange={(e: any) => {
                              OnChangeValueInput(e.target.value);
                            }}
                          />
                        </FormControl> */}
                        <FormControl my={2} w={"75%"}>
                          <FormLabel
                            fontWeight={"bold"}
                            fontSize={"16px"}
                            mt={2}
                          >
                            Informe o Copia e Cola a pagar
                          </FormLabel>
                          <Input
                            type="text"
                            name="chavePix"
                            placeholder="Informe o Copia e Cola"
                            value={pagamento.chavePix}
                            onChange={handleInputChange}
                            onBlur={() => {
                              const chaveFormatada = formatarChavePix(
                                pagamento.chavePix,
                                pagamento.tipoChave
                              );
                              setPagamento({
                                ...pagamento,
                                valor: 1,
                                tipoChave: "EMV",
                                chavePix: chaveFormatada,
                                tipoPix: "CHAVE",
                              });
                            }}
                          />
                        </FormControl>
                        <FormControl my={2} mx={2}>
                          <FormLabel
                            fontWeight={"bold"}
                            fontSize={"16px"}
                            mt={2}
                          >
                            Observação
                          </FormLabel>
                          <Input
                            placeholder="observações..."
                            value={pagamento.observacao}
                            {...register("observacao")}
                            onChange={(e: any) => {
                              setPagamento({
                                ...pagamento,
                                observacao: e.target.value,
                              });
                            }}
                          />
                        </FormControl>
                      </Flex>
                      <Button
                        isDisabled={
                          pagamento.tipoChave &&
                            pagamento.tipoChave.length > 0 &&
                            pagamento.chavePix &&
                            pagamento.chavePix.length > 0
                            ? false
                            : true
                        }
                        type="submit"
                        onClick={() => {
                          setTipoPix("CHAVE");
                          setPagamento({ ...pagamento, tipoPix: "CHAVE" });
                          setOpenCodeModal(true)
                        }}
                        mt={5}
                        leftIcon={<FiPlus />}
                        bgColor={colors.BLUEMONEDDBUTTONS}
                        style={{ color: "white", alignSelf: "flex-start" }}
                        _hover={{ bg: "#4B4B57" }}
                        isLoading={loadingCadastro}
                      >
                        Efetuar Transferência Com Copia e Cola
                      </Button>
                    </Flex>
                  </form>
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Flex>
        </Box>
      </Flex>

      <ModalConfirmTransf
        isOpen={openCodeModal}
        setIsOpen={setOpenCodeModal}
        functionPai={onSubmit}
        setCode={setCode}
        type={"transferencia"}
        email={user.email}
        transferData={transferData}
      />
    </Flex>
  );
}
